// extracted by mini-css-extract-plugin
export var icon = "_qb-0";